import React, { memo } from 'react'
import { Text } from 'react-native'
import { PromptSuccessIcon } from '../../../../assets/icons'
import { SuccessFailurePrompt } from '../../../../ui/molecules/SuccessFailurePrompt'

interface AddNewBankAccountFlow_SUCCESSProps {
  onClose: () => void
}

export const AddNewBankAccountFlow_SUCCESS: React.FC<AddNewBankAccountFlow_SUCCESSProps> =
  memo(({ onClose }) => {
    return (
      <SuccessFailurePrompt
        visible={true}
        exitable={false}
        onDismiss={onClose}
        contentContainerStyle={{ marginHorizontal: 40 }}
        title={`Bank account linked`}
        textContentBottomMargin={33}
        icon={<PromptSuccessIcon />}
        message={
          <Text testID={'add-new-bank-account-success-message'}>
            {`Your bank account has been successfully linked to your BlueTape account.`}
          </Text>
        }
        buttonData={{ title: 'Done', onPress: onClose, style: { width: 150 } }}
      />
    )
  })
